var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0647 0.958128C16.3902 1.28356 16.3902 1.8112 16.0647 2.13664L6.04738 12.154L0.744078 6.85068C0.418641 6.52525 0.418641 5.99761 0.744078 5.67217C1.06951 5.34674 1.59715 5.34674 1.92259 5.67217L6.04738 9.79696L14.8862 0.958128C15.2116 0.632691 15.7393 0.632691 16.0647 0.958128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheck);
export default __webpack_public_path__ + "static/media/WhiteCheck.f3482e80708a084f52b2db940a63c631.svg";
export { ForwardRef as ReactComponent };